import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BoardMedium_URL, BoardStatusUpdateAPI } from "../../config";

// fetch all boards
export const fetchBoards = createAsyncThunk("boards/fetchBoards", async () => {
  const res = await axios.get(`${BoardMedium_URL}/all-boards`);
  return res.data.data; // array of boards
});

// create new board
export const createBoard = createAsyncThunk(
  "boards/createBoard",
  async ({ name, description }) => {
    const res = await axios.post(`${BoardMedium_URL}/create`, {
      name,
      description,
      created_by: 1,
    });
    return res.data;
  },
);

// update board
export const updateBoard = createAsyncThunk(
  "boards/updateBoard",
  async ({ id, name, description }) => {
    const res = await axios.put(`${BoardMedium_URL}/${id}`, {
      name,
      description,
      updated_by: 1,
    });
    return res.data;
  },
);

// delete board
export const deleteBoard = createAsyncThunk(
  "boards/deleteBoard",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${BoardMedium_URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to delete board");
    }
  },
);

export const getLinkedBoardMedium = createAsyncThunk(
  "medium/get-linked-board-medium",
  async (boardId) => {
    const res = await axios.get(
      `${BoardMedium_URL}/board-mediums-details/${boardId}`,
    );
    return {
      boardId,
      linkedMediums: res.data.data, // adjust key if needed
    };
  },
);

// update board status
export const UpdateBoardStatus = createAsyncThunk(
  "boards/updateBoard",
  async ({ id, status, updated_by }) => {
    const res = await axios.patch(`${BoardStatusUpdateAPI}/${id}`, {
      status,
      updated_by,
    });
    return res.data;
  },
);

const boardSlice = createSlice({
  name: "boards",
  initialState: {
    list: [],
    linkedMediums: [],
    selectedBoardId: null,
    status: "idle",
    selectedBoard: null,
    loading: false,
  },
  reducers: {
    setSelectedBoardId: (state, action) => {
      // We update the state with the ID passed in the payload
      state.selectedBoardId = action.payload;
    },
    setSelectedBoard(state, action) {
      state.selectedBoard = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch boards
      .addCase(fetchBoards.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBoards.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchBoards.rejected, (state) => {
        state.loading = false;
      })
      // Create board
      .addCase(createBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBoard.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.loading = false;
      })
      .addCase(createBoard.rejected, (state) => {
        state.loading = false;
      })
      // Update board
      .addCase(updateBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBoard.fulfilled, (state, action) => {
        const index = state.list.findIndex((b) => b.id === action.payload.id);
        if (index !== -1) state.list[index] = action.payload;
        state.loading = false;
      })
      .addCase(updateBoard.rejected, (state) => {
        state.loading = false;
      })
      // Delete board
      .addCase(deleteBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBoard.fulfilled, (state, action) => {
        state.list = state.list.filter((b) => b.id !== action.payload);
        state.loading = false;
      })
      .addCase(deleteBoard.rejected, (state) => {
        state.loading = false;
      })
      // Get linked board medium
      .addCase(getLinkedBoardMedium.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLinkedBoardMedium.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getLinkedBoardMedium.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { setSelectedBoardId, setSelectedBoard } = boardSlice.actions;
export default boardSlice.reducer;
